import { Injectable } from '@angular/core';
import { Order, OrderType } from 'src/app/models/order.model';
import { AuthService } from '../../../auth/auth.service';
import { CoreService } from '../../../core/core.service';
import { DocketService } from '../../docket.service';

import { Observable } from 'rxjs';
import { BffService } from 'src/app/api/utils/comms/bff/bff.service';

export enum BffDispatchRequest {
  ETA = 'eta',
  BUMP_STATUS = 'bump_status',
  PRINTED = 'printed',
  SMS = 'sms',
}

export type BffOrderDispatchDate = `${number}-${number}-${number}T${number}:${number}:${number}`;
export type BffOrderDispatchBumpStatus = 'bumped' | 'new';

type BffDispatchOrders = {
  id: string;
  type: OrderType;
  location_id: string;
  value: BffOrderDispatchDate | BffOrderDispatchBumpStatus | boolean;
  single_orders: Array<string | number> | null;
};

@Injectable({
  providedIn: 'root',
})
export abstract class OrderDispatcherService {
  constructor(
    public core: CoreService,
    public docketService: DocketService,
    public auth: AuthService,
    public bffService: BffService,
  ) {}

  public UPDATE_TIMEOUT = 30000;

  /**
   * Send a request to the BFF Proxy to update an order detail
   * @param orderIDs - The list of order IDs to update
   * @param request - The type of update request
   */
  dispatchDocket(orderIDs: string[], request: BffDispatchRequest): Observable<any> {
    return new Observable(subscribe => {
      this.bffService
        .updateOrder({
          server: this.core.Active_server.label,
          bump_screen_id: this.auth.Active_bump_screen.id,
          request: request,
          orders: this.getOrdersData(orderIDs, request),
        })
        .then(payload => {
          subscribe.next(payload);
          subscribe.complete();
        })
        .catch(fail => {
          subscribe.error(fail);
          subscribe.complete();
        });
    });
  }

  /**
   * Generates the list of orders data that will be sent to BFF
   * @param ids Collection of order ids
   * @param request The type of request
   * @returns Array of BffDispatchOrders
   */
  getOrdersData(ids: string[], request: BffDispatchRequest): BffDispatchOrders[] {
    const retVal: BffDispatchOrders[] = ids.map((id: string) => {
      const order: Order = this.docketService.getOrderById(id);
      if (order) {
        return {
          id: id,
          location_id: order.location_id,
          type: order.type,
          value: order.getDispatchValue(request),
          single_orders: order.type === 'batch_order' ? order.order_ids.map(order => order.order_id) : null,
        };
      }
    });

    retVal.filter(val => val);
    return retVal;
  }

  abstract updateOrder_Drupal(sendObj: any): Observable<any>;
}
